import React, { Component } from 'react'
import { Col, Label, Row } from 'reactstrap'
import CardVeiculos from './CardVeiculos'
import { IconeCarregar } from '../../comum/components/Icones';
import { observer } from 'mobx-react';

@observer
export default class GrupoCardsVeiculos extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller

        this.cards = [
            {
                "label":"Não comparecimento (-7 dias)",
                "data": "NaoComparecimento"
            },
            {
                "label":"Cancelado incompleto (-7 dias)",
                "data": "CanceladoIncompleto"
            },
            {
                "label":"Agendados (+7 dias)",
                "data": "Agendado"
            },
            {
                "label":"Triagem (agora)",
                "data": "Triagem"
            },
            { 
                "label":"Pátio (agora)",
                "data": "Patio"
            }, {
                "label":"Saída (-7 dias)",
                "data": "Saida"
            }
        ];

        this.render = this.render.bind(this)
    }

    renderGrupos() {
        if(this.controller.loadingVeiculos){
            return (<IconeCarregar tamanho="2x" />)
        }else if(!this.controller.dadosTransportes){
            return null
            //TODO: Na verdade isso deve indicar algum erro com o servidor ou alguma outra coisa, eu deveria ver o que colocar caso nada seja encontrado
        }else{
            return(<Row className="align-items-end">
                    {
                        this.cards.map((card, index) => {
                            return(
                                <Col key={index} xs={12} sm={6} md={4} lg={4} xl={2}>
                                    <Label style={{color:"#637482"}}>{card.label}</Label>
                                    <CardVeiculos dados={this.controller.dadosTransportes[card.data]}  />
                                </Col>
                            );
                        })
                    }
                </Row>)
        }
    }

    render() {
        return (
            <div>
                {this.renderGrupos()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/veiculos/components/GrupoCardsVeiculos.js